import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

import Home from "../pages/home.vue";
import Index from "../pages/index.vue";
import Publicvoting from "../pages/publicvoting.vue";
import Detail from "../pages/detail.vue";
import Pingshen from "../pages/pingshen.vue";

const router = new VueRouter({
  // 我在所有路由的 meta 对象中添加了个 headerNavIndex 字段，该字段表示，当切换到该路由后，Header中导航菜单中应该被激活菜单的下标
  // 在有左侧菜单的页面的 meta 对象中添加了个 leftNavIndex 字段，该字段表示，当切换到该路由后，左侧菜单中应该被激活菜单的下标
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        // 首页
        {
          path: "",
          name: "index",
          component: Index,
          meta: {
            headerNavIndex: 0,
            metaInfo: {
              title: "活动简介"
            }
          }
        },
        // 公示投票
        {
          path: "/publicvoting",
          name: "publicvoting",
          component: Publicvoting,
          meta: {
            headerNavIndex: 1,
            metaInfo: {
              title: "公示投票"
            }
          }
        },
        // 详情页
        {
          path: "/detail",
          name: "detail",
          component: Detail,
          meta: {
            headerNavIndex: 1,
            metaInfo: {
              title: "详情页"
            }
          }
        },
        // 评审页
        {
          path: "/pingshen",
          name: "pingshen",
          component: Pingshen,
          meta: {
            headerNavIndex: 2,
            metaInfo: {
              title: "专家评审"
            }
          }
        }
      ]
    }
  ]
});

// 路由导航守卫
// 全局后置钩子
router.afterEach((to, from) => {
  // 更新Header菜单导航的当前激活菜单的下标
  store.commit("updateHeaderNavIndex", to.meta.headerNavIndex || 0);
  // 更新内页左侧菜单被激活菜单的下标
  // store.commit("updateLeftNavIndex", to.meta.leftNavIndex || 1);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js